import { Field, FieldProps } from 'formik';

import { FormControl } from '@@/form-components/FormControl';
import { Input } from '@@/form-components/Input';

import { useNotificationChannel } from '../useNotificationChannel';

import { ChannelFieldsProps } from './types';

export function MsTeamsChannelFields({ index }: ChannelFieldsProps) {
  const channel = useNotificationChannel(index);

  return (
    <div className="space-y-3">
      <Field name={`notificationChannels.${index}.config.name`}>
        {({ field, meta }: FieldProps<string>) => (
          <FormControl
            label="Name"
            size="vertical"
            inputId={`msteams-name-${channel.id}`}
            errors={meta.touched ? meta.error : undefined}
            required
          >
            <Input
              id={`msteams-name-${channel.id}`}
              name={field.name}
              value={field.value || ''}
              onChange={field.onChange}
              onBlur={field.onBlur}
              placeholder="Microsoft Teams Alerts"
              data-cy={`msteams-name-${channel.id}`}
              className="w-full"
            />
          </FormControl>
        )}
      </Field>
      <Field name={`notificationChannels.${index}.config.webhook_url`}>
        {({ field, meta }: FieldProps<string>) => (
          <FormControl
            label="Webhook URL"
            size="vertical"
            inputId={`msteams-webhook-url-${channel.id}`}
            errors={meta.touched ? meta.error : undefined}
            required
          >
            <Input
              id={`msteams-webhook-url-${channel.id}`}
              name={field.name}
              value={field.value || ''}
              onChange={field.onChange}
              onBlur={field.onBlur}
              placeholder="https://outlook.office.com/webhook/..."
              data-cy={`msteams-webhook-${channel.id}`}
              className="w-full"
            />
            <p className="text-gray-500 th-dark:text-gray-400 mt-1 text-xs">
              More info about configuring Microsoft Teams (New Teams) Webhooks:{' '}
              <a
                href="https://learn.microsoft.com/en-us/microsoftteams/platform/webhooks-and-connectors/how-to/add-incoming-webhook"
                target="_blank"
                rel="noopener noreferrer"
              >
                https://learn.microsoft.com/en-us/microsoftteams/platform/webhooks-and-connectors/how-to/add-incoming-webhook
              </a>
            </p>
          </FormControl>
        )}
      </Field>
    </div>
  );
}
